import {toRaw} from "vue";
import {db} from "@/modules/localDB/localDB";
import {getCurrentLocalHistory} from "@/modules/localDB/bookQuery";
import {getInitAttribute} from  "@/modules/sync/synchronizer";
import {useTool} from "@/modules/reader/tools/tools"
/**
 * Save history to db every time when new drawing is added
 * @param drawAttribute
 * @param targetPage
 * @param history
 * @returns {Promise<*>}
 */
const saveDrawHistory = async ( drawAttribute, targetPage, history) => {
    
    let record = await getCurrentLocalHistory();
    let currentToolHistory = record.toolHistory;
    let pagesWithLocalChange = [];

    //attempt to save in the format that is compatible to those for backup/restore to ease the sync work
    let updatedHistory = {
        size: drawAttribute.size,
        isEraser: drawAttribute.isEraser,
        points: history,
        type:drawAttribute.type,
        color:drawAttribute.color
    }

    let finalResult = {};

    //if there is existing toolHistory, retrieve the current data and update with the new history
    if (currentToolHistory) {

        //check to see if there is history on current page
        if (currentToolHistory[targetPage]) {
            //if not erase all, history should have content, otherwise, just leave an empty array
            if (history.length) {
                if (!currentToolHistory[targetPage].brush) {
                    currentToolHistory[targetPage].brush = [];
                }
                currentToolHistory[targetPage].brush.push(updatedHistory)
            } else {
                console.log("yes! empty " + targetPage)
                currentToolHistory[targetPage].brush = [];
            }
        } else {
            currentToolHistory[targetPage] = getInitAttribute();
            if (history.length) {
                currentToolHistory[targetPage].brush.push(updatedHistory)
            }
        }

        finalResult = currentToolHistory;

    } else {
        finalResult[targetPage] =  getInitAttribute();
        finalResult[targetPage].brush.push(updatedHistory)
    }


    if (record.pagesWithLocalChange) {
        pagesWithLocalChange = record.pagesWithLocalChange;
    }

    if (pagesWithLocalChange.indexOf(targetPage) < 0) {
        pagesWithLocalChange.push(targetPage)
    }

    console.log("FinalResult @" + targetPage)
    console.log(finalResult)
    console.log(finalResult[targetPage])

    //Note that current page local change will always be set to true if new drawing is added. Will be set to false once restoring has been operated.
    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({toolHistory: finalResult, pagesWithLocalChange:pagesWithLocalChange});

}

/**
 * Store to local history every time note is added, or position / content changed
 */
const saveNoteHistory = async (targetPage, history) =>{

    let record = await getCurrentLocalHistory();
    let currentToolHistory = record.toolHistory;
    let pagesWithLocalChange = [];

    let finalResult = {};

    //if there is existing toolHistory, retrieve the current data and update with the new history
    if (currentToolHistory) {
        if (currentToolHistory[targetPage]) {
            if (!currentToolHistory[targetPage].note) {
                currentToolHistory[targetPage].note = [];
            }
            currentToolHistory[targetPage].note.push(history);
        } else {
            currentToolHistory[targetPage] = getInitAttribute();
            currentToolHistory[targetPage].note.push(history);
        }
        finalResult = currentToolHistory;
    } else {
        finalResult[targetPage] = getInitAttribute();
        finalResult[targetPage].note.push(history);
    }

    if (record.pagesWithLocalChange) {
        pagesWithLocalChange = record.pagesWithLocalChange;
    }

    if (pagesWithLocalChange.indexOf(targetPage) < 0) {
        pagesWithLocalChange.push(targetPage)
    }

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({toolHistory: finalResult, pagesWithLocalChange:pagesWithLocalChange});
}

const updateSingeNoteHistory = async (targetPage, history) =>{

    let record = await getCurrentLocalHistory();
    let currentToolHistory = record.toolHistory;

    let pagesWithLocalChange = [];

    let currentNoteData =  currentToolHistory[targetPage].note;
    let noteIndex;
    let finalResult;
    for (let [index,item] of currentNoteData.entries()) {
        if (item.id === history.id) {
            noteIndex = index;
            break;
        }
    }

    //use toRaw to get the plain value of the reactive note data, so that it's compatible with IndexedDB
    currentNoteData[noteIndex] = toRaw(history);
    currentToolHistory[targetPage].note  = currentNoteData;
    finalResult=currentToolHistory;

    if (record.pagesWithLocalChange) {
        pagesWithLocalChange = record.pagesWithLocalChange;
    }

    if (pagesWithLocalChange.indexOf(targetPage) < 0) {
        pagesWithLocalChange.push(targetPage)
    }

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({toolHistory: finalResult, pagesWithLocalChange:pagesWithLocalChange});

}

const updateAllNoteHistory  = async (targetPage, history) =>{

    let record = await getCurrentLocalHistory();
    let currentToolHistory = record.toolHistory;

    let pagesWithLocalChange = [];
    if (record.pagesWithLocalChange) {
        pagesWithLocalChange = record.pagesWithLocalChange;
    }

    if (pagesWithLocalChange.indexOf(targetPage) < 0) {
        pagesWithLocalChange.push(targetPage)
    }

    currentToolHistory[targetPage].note = toRaw(history);

    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({toolHistory:  currentToolHistory, pagesWithLocalChange:pagesWithLocalChange});

}

/**
 * Update db with the remote backup data. Should be operated during restoring.
 * All local changes that are not found (i.e. not having been backup) on server will be discarded.
 * That means it'll be intersecting the local and remote history
 */
const updateFromRemoteHistory = async (remoteHistory)=>{

    console.log("updateFromRemoteHistory")

    let localRecord = await getCurrentLocalHistory();

    //we dont' need the url data, so delete ths entry
    for (let [page, history] of Object.entries(remoteHistory)) {
        delete remoteHistory[page].url;
    }

    console.log('@updateFromRemoteHistory remoteHistory:')
    console.log(remoteHistory)

    console.log('@updateFromRemoteHistory record.toolHistory:');
    console.log(localRecord.toolHistory);

    console.log("@updateFromRemoteHistory record.pagesWithLocalChange");
    console.log(localRecord.pagesWithLocalChange)


    if (localRecord.pagesWithLocalChange) {
        for (let page of localRecord.pagesWithLocalChange) {
            if (!remoteHistory[page]) {
                delete localRecord.toolHistory[page]
            }
        }
    }

    console.log('@updateFromRemoteHistory after intersecting:')
    console.log(localRecord.toolHistory)

    let finalHistory = {...localRecord.toolHistory, ...remoteHistory};

    console.log('updateFromRemoteHistory finalHistory');
    console.log(finalHistory)

    //Note that hasLocalChange is always set to false when restoring. It'll be set to true after user has made new drawing.
    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({toolHistory: finalHistory, pagesWithLocalChange:null});

}

/**
 * Set pagesWithLocalChange to false after backup, so that the application can determine if all data have been sync to server
 */
const setLocalUnChanged = async()=> {
    return await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({pagesWithLocalChange:null, isBookMarkChanged:false});
}



export {
    saveDrawHistory,
    saveNoteHistory,
    updateSingeNoteHistory,
    updateAllNoteHistory,
    updateFromRemoteHistory,
    setLocalUnChanged
}